import React from "react";
import "./title.css";

interface TitleProps {
  children: React.ReactNode;
}

const Title: React.FC<TitleProps> = ({ children }) => {
  return <h1 className="title-base">{children}</h1>;
};

export default Title;
